function SidebarNavHeader(props: {children: React.ReactNode[]}) {
    return (
        <h4 className="px-6 py-3 text-sm text-grey-300 font-bold uppercase tracking-wide">
            {props.children}
        </h4>
    );
}
export default SidebarNavHeader;